module.exports = __webpack_public_path__ + "img/expand.0ded1f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/expand.png
// module id = 9hnS
// module chunks = 4